import React from 'react';
import './Contact.css';

const Contact = () => (
  <div className="contact-page">
    <div className="contact-card">
      <h1>Contact Me</h1>
      <form className="contact-form" target="_blank" action="https://formsubmit.co/lankfordr51@gmail.com" method="POST">
        <input type="text" name="name" className="contact-input" placeholder="Full Name" required />
        <input type="email" name="email" className="contact-input" placeholder="Email Address" required />
        <textarea name="message" className="contact-textarea" placeholder="Your Message" rows="6" required></textarea>
        <button type="submit" className="contact-btn">Send Message</button>
      </form>
      <div className="contact-info">
        <div><strong>Email:</strong> lankfordr51@gmail.com</div>
        {/* <div><strong>Phone:</strong> 972-341-7772</div> */}
        <div><strong>GitHub:</strong> <a href="https://github.com/Rodrick12123" target="_blank" rel="noopener noreferrer">Rodrick12123</a></div>
      </div>
    </div>
  </div>
);

export default Contact; 